module.exports = __webpack_public_path__ + "img/icon-add.52b45f13.svg";